import type { CoreConfiguration } from './types';

const defaultProps: CoreConfiguration = {
    exposeLibraryMetadata: true,
    showPayButton: true
};

export { defaultProps };
